import { ModifyResComponent } from './modify-res/modify-res.component';
import { ComponentsModule } from '../../components';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';


const routes: Routes = [
    { path: '', component: ModifyResComponent }
];

@NgModule({
    imports: [
        RouterModule.forChild(routes),
        CommonModule,
        ComponentsModule
    ],
    declarations: [
      ModifyResComponent
    ],
    exports: [
        ModifyResComponent
    ]
})
export class ModifyResModule {
    constructor() {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/routes/modify-res/modify-res.module.ts